import { useEffect, useState } from "react";

function useNavTimeout(init, delay) {
  const [data, setData] = useState(init);

  // Set up the timeout.
  useEffect(() => {
    // Don't schedule if no delay is specified.
    if (delay === null) {
      return;
    }

    const id = setTimeout(() => setData((prev) => !prev), data ? delay : 0);

    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [init, delay]);

  return data;
}

export default useNavTimeout;
